import { IComponentType, } from '@r3f-component-data-structure/index';
export function createSpatialComponent(spatialComponentType, spatialComponentData) {
    const spatialComponent = {
        type: spatialComponentType,
        ...spatialComponentData,
    };
    return spatialComponent;
}
export const createScreenAnchorGroup = (anchorPositionType) => {
    return {
        type: IComponentType.ScreenAnchorGroup,
        anchorPositionType,
        children: [],
    };
};
export const createFaceLandmarkGroup = (landmark) => {
    return {
        type: IComponentType.FaceLandmarkGroup,
        landmark,
        children: [],
    };
};
